import { useCallback, useState } from "react";

const STORAGE_KEY = "wf-canvas-theme";

/**
 * A small, self-contained dark mode for just the Workflows canvas — the rest
 * of the app has no dark theme, so this doesn't touch MUI's global theme,
 * only the `data-wf-theme` attribute the hand-styled canvas CSS reads (see
 * `.wf-root[data-wf-theme="dark"]` in workflows.css). Per-browser only
 * (localStorage), not a real user preference synced anywhere.
 */
export function useWorkflowTheme() {
  const [theme, setTheme] = useState<"light" | "dark">(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light";
    } catch {
      return "light";
    }
  });

  const toggleTheme = useCallback(() => {
    setTheme((prev) => {
      const next = prev === "dark" ? "light" : "dark";
      try {
        localStorage.setItem(STORAGE_KEY, next);
      } catch {
        /* best-effort — theme just won't persist across reloads */
      }
      return next;
    });
  }, []);

  return { theme, toggleTheme };
}
